(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oralie-collection-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduceMotion.matches) return;

    document.querySelectorAll('[data-oralie-collection-stretch]').forEach((hero) => {
      if (hero.dataset.stretchReady === 'true') return;

      const media = hero.querySelector('[data-oralie-stretch-media]');
      const image = hero.querySelector('.oralie-collection-hero__image');
      if (!media || !image) return;

      hero.dataset.stretchReady = 'true';

      let lastScrollY = window.scrollY;
      let progress = 0;
      let pullDown = 0;
      let elastic = 0;
      let elasticTarget = 0;
      let frame = 0;
      let releaseTimer = 0;

      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

      const render = () => {
        frame = 0;

        const rect = hero.getBoundingClientRect();
        const height = Math.max(hero.offsetHeight, 1);
        const progressTarget = clamp(-rect.top / height, 0, 1);
        const pullDownTarget = clamp(-window.scrollY / 180, 0, 0.08);

        progress += (progressTarget - progress) * 0.075;
        pullDown += (pullDownTarget - pullDown) * 0.08;
        elastic += (elasticTarget - elastic) * 0.08;

        const scale = 1.045 + progress * 0.075 + Math.max(elastic, 0) * 0.65 + pullDown;
        const translateY = progress * -22 + pullDown * 45;
        const elasticScale = 1 + Math.max(elastic, 0) * 0.18 + pullDown * 0.3;

        image.style.setProperty('--oralie-stretch-scale', scale.toFixed(4));
        image.style.setProperty('--oralie-stretch-y', `${translateY.toFixed(2)}px`);
        media.style.setProperty('--oralie-stretch-elastic', elasticScale.toFixed(4));

        if (
          Math.abs(progressTarget - progress) > 0.0005 ||
          Math.abs(pullDownTarget - pullDown) > 0.0005 ||
          Math.abs(elasticTarget - elastic) > 0.0005
        ) {
          frame = window.requestAnimationFrame(render);
        }
      };

      const requestRender = () => {
        if (!frame) frame = window.requestAnimationFrame(render);
      };

      const handleScroll = () => {
        const currentScrollY = window.scrollY;
        const delta = currentScrollY - lastScrollY;
        lastScrollY = currentScrollY;

        elasticTarget = clamp(delta / 260, -0.015, 0.055);
        window.clearTimeout(releaseTimer);
        releaseTimer = window.setTimeout(() => {
          elasticTarget = 0;
          requestRender();
        }, 180);

        requestRender();
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', requestRender, { passive: true });
      requestRender();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oralie-header"]) return;
  try {
    
  class OralieHeader extends HTMLElement {
    connectedCallback() {
      this.menuButton = this.querySelector('[data-menu-toggle]');
      this.primary = this.querySelector('.oralie-header__primary');
      this.panelToggles = Array.from(this.querySelectorAll('[data-panel-toggle]'));
      this.panes = Array.from(this.querySelectorAll('[data-menu-pane]'));
      this.panel = this.querySelector('[data-menu-panel]');
      this.closeTargets = this.querySelectorAll('[data-menu-close]');
      this.isOpen = false;
      this.isDropdown = false;
      this.currentPanel = 'products';
      this.lastTrigger = null;
      this.dropdownCloseTimer = null;
      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.desktopToggles = Array.from(this.querySelectorAll('.oralie-header__desktop-link[data-panel-toggle]'));
      this.onScroll = this.updateScrollState.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onViewportResize = this.updatePanelViewport.bind(this);

      this.menuButton?.addEventListener('click', () => this.toggle(this.menuButton, 'products'));
      this.panelToggles.forEach((trigger) => trigger.addEventListener('click', () => this.handlePanelToggle(trigger)));
      this.desktopToggles.forEach((trigger) => {
        trigger.addEventListener('pointerenter', () => this.openDropdown(trigger, trigger.dataset.panelToggle));
        trigger.addEventListener('focus', () => this.openDropdown(trigger, trigger.dataset.panelToggle));
      });
      this.addEventListener('pointerenter', () => this.cancelDropdownClose());
      this.addEventListener('pointerleave', () => this.scheduleDropdownClose());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.scheduleDropdownClose(0);
      });
      this.closeTargets.forEach((target) => target.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onViewportResize, { passive: true });
      window.visualViewport?.addEventListener('resize', this.onViewportResize, { passive: true });
      const announcement = document.querySelector('.announcement-bar-section');
      const headerSection = this.closest('.oralie-header-section');
      if (announcement && headerSection) {
        const updateAnnouncementHeight = () => {
          headerSection.style.setProperty('--oralie-announcement-height', `${announcement.getBoundingClientRect().height}px`);
        };
        this.announcementObserver = new ResizeObserver(updateAnnouncementHeight);
        this.announcementObserver.observe(announcement);
        updateAnnouncementHeight();
      } else if (headerSection) {
        headerSection.style.setProperty('--oralie-announcement-height', '0px');
      }
      this.updateScrollState();
    }

    disconnectedCallback() {
      this.announcementObserver?.disconnect();
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onViewportResize);
      window.visualViewport?.removeEventListener('resize', this.onViewportResize);
      this.cancelDropdownClose();
      if (this.isOpen) document.body.classList.remove('oralie-menu-open');
    }

    handlePanelToggle(trigger) {
      const panelName = trigger.dataset.panelToggle || 'products';
      if (trigger.classList.contains('oralie-header__desktop-link') && this.desktopQuery.matches) {
        this.openDropdown(trigger, panelName);
        return;
      }
      if (this.isOpen && this.currentPanel === panelName && trigger.classList.contains('oralie-header__desktop-link')) {
        this.close();
        return;
      }
      if (this.isOpen) {
        this.setPanel(panelName);
      } else {
        this.open(trigger, panelName);
      }
    }

    setPanel(panelName) {
      if (this.currentPanel !== panelName && this.panel) this.panel.scrollTop = 0;
      this.currentPanel = panelName;
      this.panes.forEach((pane) => {
        pane.hidden = pane.dataset.menuPane !== panelName;
      });
      this.panelToggles.forEach((trigger) => {
        const active = trigger.dataset.panelToggle === panelName;
        trigger.classList.toggle('is-active', active);
        trigger.toggleAttribute('aria-current', active);
        trigger.setAttribute('aria-expanded', (this.isOpen || this.isDropdown) && active ? 'true' : 'false');
      });
      this.dataset.activePanel = panelName;
    }

    toggle(trigger, panelName) {
      if (this.isOpen) {
        this.close();
      } else {
        this.open(trigger, panelName);
      }
    }

    open(trigger, panelName = 'products') {
      this.closeDropdown();
      this.isOpen = true;
      this.lastTrigger = trigger;
      this.classList.add('is-open');
      this.menuButton?.setAttribute('aria-expanded', 'true');
      this.menuButton?.setAttribute('aria-label', 'إغلاق القائمة');
      this.panel?.setAttribute('aria-hidden', 'false');
      this.setPanel(panelName);
      document.body.classList.add('oralie-menu-open');
      if (this.panel) this.panel.scrollTop = 0;
      this.updatePanelViewport();
      const activePane = this.panes.find((pane) => pane.dataset.menuPane === panelName);
      const firstLink = activePane?.querySelector('a');
      window.setTimeout(() => firstLink?.focus({ preventScroll: true }), 180);
    }

    openDropdown(trigger, panelName = 'products') {
      if (!this.desktopQuery.matches) return;
      if (this.isOpen) {
        this.setPanel(panelName);
        return;
      }
      this.cancelDropdownClose();
      this.isDropdown = true;
      this.lastTrigger = trigger;
      const rootRect = this.getBoundingClientRect();
      const alignmentRect = this.primary?.getBoundingClientRect() || trigger.getBoundingClientRect();
      const rightOffset = Math.max(42, rootRect.right - alignmentRect.right);
      this.style.setProperty('--oralie-dropdown-right', `${rightOffset}px`);
      this.classList.add('is-dropdown');
      this.panel?.setAttribute('aria-hidden', 'false');
      this.setPanel(panelName);
      this.updatePanelViewport();
    }

    scheduleDropdownClose(delay = 170) {
      if (!this.isDropdown) return;
      this.cancelDropdownClose();
      this.dropdownCloseTimer = window.setTimeout(() => this.closeDropdown(), delay);
    }

    cancelDropdownClose() {
      if (!this.dropdownCloseTimer) return;
      window.clearTimeout(this.dropdownCloseTimer);
      this.dropdownCloseTimer = null;
    }

    closeDropdown() {
      this.cancelDropdownClose();
      if (!this.isDropdown) return;
      this.isDropdown = false;
      this.classList.remove('is-dropdown');
      this.panelToggles.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      if (!this.isOpen) this.panel?.setAttribute('aria-hidden', 'true');
    }

    close() {
      if (this.isDropdown) {
        this.closeDropdown();
        return;
      }
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      this.menuButton?.setAttribute('aria-expanded', 'false');
      this.menuButton?.setAttribute('aria-label', 'فتح القائمة');
      this.panelToggles.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      this.panel?.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('oralie-menu-open');
      this.lastTrigger?.focus({ preventScroll: true });
    }

    handleKeydown(event) {
      if (!this.isOpen && !this.isDropdown) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        if (this.isDropdown) this.closeDropdown();
        else this.close();
        return;
      }
      if (this.isDropdown) return;
      if (event.key !== 'Tab') return;
      const focusable = Array.from(this.querySelectorAll('a[href], button:not([disabled])')).filter(
        (element) => element.offsetParent !== null
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    updateScrollState() {
      this.classList.toggle('is-scrolled', window.scrollY > 48);
      this.updatePanelViewport();
    }

    updatePanelViewport() {
      if ((!this.isOpen && !this.isDropdown) || !this.panel) return;
      const panelTop = Math.max(0, this.getBoundingClientRect().top + this.panel.offsetTop);
      this.style.setProperty('--oralie-panel-top', `${panelTop}px`);
    }
  }

  if (!customElements.get('oralie-header')) {
    customElements.define('oralie-header', OralieHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oralie-home-seed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeJourneys = (scope) => {
      scope.querySelectorAll('[data-osh-journey]').forEach((root) => {
        if (root.dataset.journeyReady === 'true') return;
        const tablist = root.querySelector('[role="tablist"]');
        const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
        const panels = Array.from(root.querySelectorAll('[data-journey-panel]'));
        if (!tablist || !tabs.length || tabs.length !== panels.length) return;

        const selectStage = (index, focus = false) => {
          tabs.forEach((tab, stage) => {
            const selected = stage === index;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            panels[stage].hidden = !selected;
          });
          if (focus) tabs[index].focus();
        };

        panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabs[index].id);
          panel.tabIndex = 0;
        });
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => selectStage(index));
          tab.addEventListener('keydown', (event) => {
            let nextIndex;
            const rtl = getComputedStyle(root).direction === 'rtl';
            if (event.key === 'ArrowLeft') nextIndex = index + (rtl ? 1 : -1);
            else if (event.key === 'ArrowRight') nextIndex = index + (rtl ? -1 : 1);
            else if (event.key === 'Home') nextIndex = 0;
            else if (event.key === 'End') nextIndex = tabs.length - 1;
            else return;
            event.preventDefault();
            selectStage((nextIndex + tabs.length) % tabs.length, true);
          });
        });
        selectStage(0);
        tablist.hidden = false;
        root.dataset.journeyReady = 'true';
      });
    };
    initializeJourneys(document);
    document.addEventListener('shopify:section:load', (event) => initializeJourneys(event.target));
  })();

  (() => {
    const sections = document.querySelectorAll('[data-osh-seed-story]');
    if (!sections.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-visible', entry.isIntersecting);
      });
    }, { threshold: 0.18 });

    sections.forEach((section) => observer.observe(section));
    if (reducedMotion) return;

    let frame = null;
    const update = () => {
      frame = null;
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / (window.innerHeight + rect.height)));
        section.style.setProperty('--osh-story-scale', (1.06 + progress * 0.025).toFixed(4));
      });
    };

    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
  })();

  (() => {
    const initializeStories = (scope) => scope.querySelectorAll('[data-osh-video-stories]').forEach((root) => {
      if (root.dataset.playerReady) return;
      const video = root.querySelector('video');
      const playButton = root.querySelector('[data-story-play]');
      const soundButton = root.querySelector('[data-story-sound]');
      const fullscreenButton = root.querySelector('[data-story-fullscreen]');
      const controls = root.querySelector('[data-story-controls]');
      if (!video || !playButton || !soundButton || !fullscreenButton || !controls) return;
      root.dataset.playerReady = 'true';
      video.controls = false;
      controls.hidden = false;
      fullscreenButton.hidden = !(video.requestFullscreen || video.webkitEnterFullscreen);

      const updateControls = () => {
        const playing = !video.paused && !video.ended;
        playButton.setAttribute('aria-pressed', String(playing));
        playButton.setAttribute('aria-label', playing ? root.dataset.pauseLabel : root.dataset.playLabel);
        soundButton.setAttribute('aria-pressed', String(!video.muted));
        soundButton.setAttribute('aria-label', video.muted ? root.dataset.unmuteLabel : root.dataset.muteLabel);
      };
      const togglePlayback = () => {
        if (video.paused || video.ended) {
          video.play().catch(() => {
            video.controls = true;
            updateControls();
          });
        } else video.pause();
      };
      playButton.addEventListener('click', togglePlayback);
      video.addEventListener('click', () => {
        if (!video.controls) togglePlayback();
      });
      soundButton.addEventListener('click', () => { video.muted = !video.muted; });
      ['play', 'pause', 'ended', 'volumechange'].forEach((event) => video.addEventListener(event, updateControls));
      fullscreenButton.addEventListener('click', () => {
        video.controls = true;
        if (video.requestFullscreen) {
          video.requestFullscreen().catch(() => { video.controls = false; });
        } else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
      });
      video.addEventListener('fullscreenchange', () => {
        video.controls = document.fullscreenElement === video;
      });
      video.addEventListener('webkitendfullscreen', () => { video.controls = false; });
      updateControls();
    });
    initializeStories(document);
    document.addEventListener('shopify:section:load', (event) => initializeStories(event.target));
  })();

  (() => {
    const initializeEditorial = (scope) => scope.querySelectorAll('[data-osh-editorial-stories]').forEach((section) => {
      if (section.dataset.editorialReady) return;
      const stage = section.querySelector('.osh-editorial-stories__stage');
      const track = section.querySelector('.osh-editorial-stories__track');
      if (!stage || !track) return;
      section.dataset.editorialReady = 'true';

      const controller = new AbortController();
      const { signal } = controller;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let maxTravel = 0;
      let previousScrollOffset = 0;
      let frame = 0;
      let pointerId = null;
      let pointerStartX = 0;
      let pointerStartOffset = 0;

      // Native RTL scrolling keeps touch momentum and remains usable without JS.
      const offset = () => -stage.scrollLeft;
      const setOffset = (value) => {
        stage.scrollLeft = -Math.max(0, Math.min(maxTravel, value));
      };
      const scrollOffset = () => {
        const { top, height } = stage.getBoundingClientRect();
        return Math.max(0, Math.min(window.innerHeight + height, window.innerHeight - top)) * .5;
      };
      const update = () => {
        frame = 0;
        const nextOffset = scrollOffset();
        if (!reducedMotion.matches && pointerId === null) {
          setOffset(offset() + nextOffset - previousScrollOffset);
        }
        previousScrollOffset = nextOffset;
      };
      const requestUpdate = () => {
        if (!frame) frame = window.requestAnimationFrame(update);
      };
      const measure = () => {
        maxTravel = Math.max(0, stage.scrollWidth - stage.clientWidth);
        requestUpdate();
      };
      const endDrag = (event) => {
        if (event.pointerId !== pointerId) return;
        pointerId = null;
        stage.classList.remove('is-dragging');
        if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
      };

      track.querySelectorAll('img').forEach((image) => { image.draggable = false; });
      stage.addEventListener('pointerdown', (event) => {
        // Touch/pen gestures use the browser's native scrolling and inertia.
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointerId = event.pointerId;
        pointerStartX = event.clientX;
        pointerStartOffset = offset();
        stage.classList.add('is-dragging');
        stage.setPointerCapture(pointerId);
      }, { signal });
      stage.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        setOffset(pointerStartOffset + event.clientX - pointerStartX);
      }, { signal });
      stage.addEventListener('pointerup', endDrag, { signal });
      stage.addEventListener('pointercancel', endDrag, { signal });
      stage.addEventListener('lostpointercapture', endDrag, { signal });

      // Vertical wheel scrolling stays on the page; horizontal gestures stay native.
      stage.addEventListener('keydown', (event) => {
        const step = Math.max(180, stage.clientWidth * .42);
        const destinations = {
          ArrowLeft: offset() + step,
          ArrowRight: offset() - step,
          Home: 0,
          End: maxTravel
        };
        if (!(event.key in destinations)) return;
        event.preventDefault();
        setOffset(destinations[event.key]);
      }, { signal });

      window.addEventListener('scroll', requestUpdate, { passive: true, signal });
      window.addEventListener('resize', measure, { passive: true, signal });
      window.addEventListener('load', measure, { once: true, signal });
      reducedMotion.addEventListener('change', () => {
        previousScrollOffset = scrollOffset();
      }, { signal });
      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(stage);
      resizeObserver.observe(track);
      measure();

      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(section)) return;
        controller.abort();
        resizeObserver.disconnect();
        window.cancelAnimationFrame(frame);
        delete section.dataset.editorialReady;
      }, { signal });
    });
    initializeEditorial(document);
    document.addEventListener('shopify:section:load', (event) => initializeEditorial(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oralie-ingredient-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-oie]');
    sections.forEach((section) => {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const reveals = section.querySelectorAll('[data-reveal]');
      if (reduced) reveals.forEach((el) => el.classList.add('is-visible'));
      else {
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
        }), { threshold: 0.14, rootMargin: '0px 0px -7% 0px' });
        reveals.forEach((el) => observer.observe(el));
      }
      const progress = section.querySelector('[data-oie-progress]');
      const media = section.querySelector('[data-oie-parallax]');
      let ticking = false;
      const update = () => {
        const rect = section.getBoundingClientRect();
        const total = Math.max(1, section.offsetHeight - window.innerHeight);
        const current = Math.min(total, Math.max(0, -rect.top));
        if (progress) progress.style.transform = `scaleX(${current / total})`;
        if (media && !reduced) media.style.transform = `scale(1.08) translate3d(0, ${Math.min(70, window.scrollY * .06)}px, 0)`;
        ticking = false;
      };
      window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oralie-story-experience"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll('[data-ose]').forEach((section)=>{const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;const els=section.querySelectorAll('[data-ose-reveal], [data-story-content] > *');if(reduced)els.forEach(el=>el.classList.add('is-visible'));else{const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target)}}),{threshold:.12,rootMargin:'0px 0px -8%'});els.forEach(el=>io.observe(el))}const bar=section.querySelector('[data-ose-progress]');const media=section.querySelector('[data-ose-parallax]');let ticking=false;const update=()=>{const rect=section.getBoundingClientRect();const total=Math.max(1,section.offsetHeight-innerHeight);const current=Math.min(total,Math.max(0,-rect.top));if(bar)bar.style.transform=`scaleX(${current/total})`;if(media&&!reduced)media.style.transform=`scale(1.08) translate3d(0,${Math.min(75,scrollY*.055)}px,0)`;ticking=false};addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(update);ticking=true}},{passive:true});update()})})();

  } catch(e) { console.error(e); }
})();
})();
